module.exports = __webpack_public_path__ + "static/img/articleAI.3181754.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/propaganda/articleAI.jpg
// module id = fzKU
// module chunks = 1